// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.
import { z } from 'zod';
import { OrganizationJitEmailDomainVerificationStatus } from './custom-types.js';
const createGuard = z.object({
    tenantId: z.string().max(21).optional(),
    id: z.string().min(1).max(21),
    organizationId: z.string().min(1).max(21),
    domain: z.string().min(1).max(256),
    verificationValue: z.string().min(1).max(256),
    status: z.nativeEnum(OrganizationJitEmailDomainVerificationStatus).optional(),
    createdAt: z.number().optional(),
    expiresAt: z.number(),
    lastCheckedAt: z.number().nullable().optional(),
    verifiedAt: z.number().nullable().optional(),
});
const guard = z.object({
    tenantId: z.string().max(21),
    id: z.string().min(1).max(21),
    organizationId: z.string().min(1).max(21),
    domain: z.string().min(1).max(256),
    verificationValue: z.string().min(1).max(256),
    status: z.nativeEnum(OrganizationJitEmailDomainVerificationStatus),
    createdAt: z.number(),
    expiresAt: z.number(),
    lastCheckedAt: z.number().nullable(),
    verifiedAt: z.number().nullable(),
});
export const OrganizationJitEmailDomainVerifications = Object.freeze({
    table: 'organization_jit_email_domain_verifications',
    tableSingular: 'organization_jit_email_domain_verification',
    fields: {
        tenantId: 'tenant_id',
        id: 'id',
        organizationId: 'organization_id',
        domain: 'domain',
        verificationValue: 'verification_value',
        status: 'status',
        createdAt: 'created_at',
        expiresAt: 'expires_at',
        lastCheckedAt: 'last_checked_at',
        verifiedAt: 'verified_at',
    },
    fieldKeys: [
        'tenantId',
        'id',
        'organizationId',
        'domain',
        'verificationValue',
        'status',
        'createdAt',
        'expiresAt',
        'lastCheckedAt',
        'verifiedAt',
    ],
    createGuard,
    guard,
    updateGuard: guard.partial(),
});
